import { motion } from "framer-motion";
import { EASE, IMAGES } from "../lib/site";

const STORIES = [
  {
    img: IMAGES.family,
    quote:
      "When the eviction notice came, DAIO paid our arrears within days. My children kept their home — and their school.",
    name: "Marisol R.",
    role: "Mother of three · Newark, NJ",
  },
  {
    img: IMAGES.classroom,
    quote:
      "The learning center gave me books, a tutor, and the belief that I could be the first in my family to attend college.",
    name: "Amina K.",
    role: "Student · Youth Education Program",
  },
];

export const Stories = () => (
  <section id="impact" data-testid="stories-section" className="bg-night py-24 text-[#FAF7F2] sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: EASE }}
      >
        <p className="eyebrow">Voices of the mission</p>
        <h2 className="mt-5 max-w-2xl font-serif text-4xl font-medium tracking-tight sm:text-5xl">
          Behind every dollar, <em className="text-warm">a life changed.</em>
        </h2>
      </motion.div>

      <div className="mt-14 grid gap-5 lg:grid-cols-3">
        {STORIES.map((s, i) => (
          <motion.figure
            key={s.name}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: i * 0.1, ease: EASE }}
            className="group overflow-hidden rounded-[28px] border border-white/10 bg-white/5"
            data-testid={`story-card-${i}`}
          >
            <div className="overflow-hidden">
              <img
                src={s.img}
                alt={s.name}
                className="aspect-[16/10] w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
            </div>
            <figcaption className="p-7">
              <blockquote className="font-serif text-xl italic leading-relaxed text-[#FAF7F2]/90">
                “{s.quote}”
              </blockquote>
              <p className="mt-5 text-sm font-semibold text-warm">{s.name}</p>
              <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.18em] text-[#FAF7F2]/50">
                {s.role}
              </p>
            </figcaption>
          </motion.figure>
        ))}

        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8, delay: 0.2, ease: EASE }}
          className="flex flex-col justify-between rounded-[28px] border border-warm/30 bg-warm/10 p-8"
          data-testid="story-card-2"
        >
          <span className="font-serif text-7xl leading-none text-warm">”</span>
          <blockquote className="mt-4 font-serif text-2xl italic leading-relaxed">
            Direct means direct. Every gift is traced to the family it
            reaches — nothing lost in between.
          </blockquote>
          <p className="mt-8 font-mono text-[10px] uppercase tracking-[0.18em] text-[#FAF7F2]/50">
            The DAIO Founding Promise
          </p>
        </motion.div>
      </div>
    </div>
  </section>
);
